export default "__VITE_ASSET__C$4IQB3A__"